air-for-share
How it works Download Upgrade Feedback Login / Register
Text
<template>
    <main class="visit-page">
        <section class="visit-shell">
            <!-- HEADER (unchanged) -->
            <app-header @show-drawer="showDrawer" @create-visit="createVisit" @logout="logout"
                heading="Primary Market Visits" subHeading="Manage dealer and market visit records."
                btnHeading="New Visit" :isFormPage="false" :allowedCreate="userRole.create" />
            <!-- <header class="visit-header">
                <div class="brand-mark">
                    <q-btn flat dense rounded @click="showDrawer">
                        <q-icon name="menu" :size="$q.screen.lt.md ? '40px' : '28px'" />
                    </q-btn>
                </div>

                <div class="header-content">
                    <img class="brand-logo-sera" src="../../assets/SERA_LOGO.png" />
                    <h1>Primary Market Visits</h1>
                    <p class="header-copy sub-heading">Manage dealer and market visit records.</p>
                </div>

                <div class="header-actions">
                    <q-btn no-caps icon="add" label="New Visit" class="new-visit-btn" title="Create" @click="createVisit" />
                    <q-btn :size="$q.screen.lt.md ? 'lg' : ''" flat dense no-caps icon="logout" title="Logout" class="logout-link" @click="logout" />
                </div>
            </header> -->

            <!-- FILTER SECTION (unchanged) -->
            <section class="filter-card">
                <div class="filter-header">
                    <div class="section-title">
                        <span class="section-icon">
                            <q-icon :size="$q.screen.lt.md ? 'md' : ''" name="list_alt" />
                        </span>

                        <div>
                            <h2>Visit Records</h2>
                            <!-- <p>Search and manage your market visits.</p> -->
                        </div>
                    </div>
                    <div>

                        <q-btn v-if="userRole.export" no-caps outline icon="file_download" label="Export Excel" class="export-btn"
                            :loading="isExporting" @click="exportToExcel(visits)" />

                        <q-btn size="lg" flat dense round icon="refresh" class="refresh-btn" :loading="isLoading"
                            @click="getVisits">
                            <q-tooltip>Refresh</q-tooltip>
                        </q-btn>
                    </div>
                </div>

                <div v-if="$q.screen.gt.sm" class="filter-grid">
                    <q-input v-model.trim="filters.search" outlined dense clearable label="Search"
                        placeholder="Visit ID, dealer, contact..." class="formField">
                        <template v-slot:prepend>
                            <q-icon name="search" />
                        </template>
                    </q-input>

                    <q-input v-model="filters.fromDate" outlined dense type="date" label="From Date"
                        class="formField" />

                    <q-input v-model="filters.toDate" outlined dense type="date" label="To Date" class="formField" />

                    <q-select v-model="filters.region" outlined dense clearable label="Region" :options="regionOptions"
                        class="formField" />

                    <q-select v-model="filters.city" outlined dense clearable label="City" :options="cityOptions"
                        class="formField" />
                    <!-- <div style="width: 100%"> -->
                    <!-- <custom-select :value="filters.region" model="region" label="Region" :options="regionOptions" @change="handleSelect" />
                        <custom-select :value="filters.city" model="city" label="City" :options="cityOptions" @change="handleSelect" />
                        <custom-select
                            :value="filters.samName"
                            model="samName"
                            label="Sales Account Manager"
                            :options="samOptions"
                            @change="handleSelect"
                        /> -->

                    <!-- </div> -->

                    <q-select v-model="filters.samName" outlined dense clearable label="Sales Account Manager"
                        :options="samOptions" class="formField" />
                </div>
                <div v-else class="filter-grid">
                    <q-expansion-item v-model="filtersExpanded" expand-separator icon="filter_list" label="Filters"
                        class="filter-expansion">
                        <div class="filter-grid">
                            <q-input v-model.trim="filters.search" outlined dense clearable label="Search"
                                placeholder="Visit ID, dealer, contact..." class="formField" expand-icon="add"
                                expanded-icon="remove" icon="filter_list">
                                <template v-slot:prepend>
                                    <q-icon name="search" />
                                </template>
                            </q-input>

                            <q-input v-model="filters.fromDate" outlined dense type="date" label="From Date"
                                class="formField" />

                            <q-input v-model="filters.toDate" outlined dense type="date" label="To Date"
                                class="formField" />

                            <advance-search-select :value="filters.region" model="region" :options="regionOptions"
                                @change="handleSelect" outlined dense label="Region" no-error-icon :disable="false"
                                hide-bottom-space class="formField" />

                            <!-- <q-select v-model="filters.region" outlined dense clearable label="Region" :options="regionOptions" class="formField">
                                <template v-slot:before-options>
                                    <q-item>
                                        <q-item-section>
                                            <q-input v-model="filterRegn" dense outlined clearable placeholder="Search Region..." @click.stop>
                                                <template v-slot:prepend>
                                                    <q-icon name="search" />
                                                </template>
                                            </q-input>
                                        </q-item-section>
                                    </q-item>

                                    <q-separator />
                                </template>
                            </q-select> -->
                            <advance-search-select :value="filters.city" model="city" :options="cityOptions"
                                @change="handleSelect" outlined dense label="City" no-error-icon :disable="false"
                                hide-bottom-space class="formField" />
                            <!-- <q-select v-model="filters.city" outlined dense clearable label="City" :options="cityOptions" class="formField">
                                <template v-slot:before-options>
                                    <q-item>
                                        <q-item-section>
                                            <q-input v-model="filtercity" dense outlined clearable placeholder="Search Region..." @click.stop>
                                                <template v-slot:prepend>
                                                    <q-icon name="search" />
                                                </template>
                                            </q-input>
                                        </q-item-section>
                                    </q-item>

                                    <q-separator />
                                </template>
                            </q-select> -->

                            <advance-search-select :value="filters.samName" model="samName" :options="samOptions"
                                @change="handleSelect" outlined dense label="Sales Account Manager" no-error-icon
                                :disable="false" hide-bottom-space class="formField" />

                            <!-- <q-select
                                v-model="filters.samName"
                                outlined
                                dense
                                clearable
                                label="Sales Account Manager"
                                :options="samOptions"
                                class="formField"
                                :menu-anchor="'bottom left'"
                                :menu-self="'top left'"
                                behavior="dialog"
                                popup-content-class="sam-select-popup"
                            >
                                <template v-slot:before-options>
                                      <q-item class="search-option-field">
                                        <q-item-section>
                                            <q-input v-model="filterSAM" dense outlined clearable placeholder="Search Region..." @click.stop>
                                                <template v-slot:prepend>
                                                    <q-icon name="search" />
                                                </template>
                                            </q-input>
                                        </q-item-section>
                                    </q-item>

                                    <q-separator />
                                </template>
                                <template v-slot:no-option>
                                    <q-item class="search-option-field">
                                        <q-item-section>
                                            <q-input v-model="filterSAM" dense outlined clearable placeholder="Search Region..." @click.stop>
                                                <template v-slot:prepend>
                                                    <q-icon name="search" />
                                                </template>
                                            </q-input>
                                        </q-item-section>
                                    </q-item>
                                    <q-separator />
                                    <q-item>
                                        <q-item-section class="text-grey"> No results </q-item-section>
                                    </q-item>
                                </template>
                            </q-select> -->
                        </div>
                    </q-expansion-item>
                    <q-separator />
                </div>

                <div class="filter-footer">
                    <div class="record-count">
                        <q-icon :size="$q.screen.lt.md ? 'md' : ''" name="description" />
                        <span>
                            {{ tableRows.length }}
                            {{ tableRows.length === 1 ? 'Visit' : 'Visits' }}
                        </span>
                    </div>

                    <q-btn v-if="hasFilters" flat dense no-caps icon="filter_alt_off" label="Clear Filters"
                        class="clear-filter-btn" @click="clearFilters" />
                </div>
            </section>

            <!-- ================= Q-TABLE (desktop + mobile grid) ================= -->
            <section class="list-card">
                <q-table ref="visitTable" :data="tableRows" :columns="columns" row-key="srNo" flat dense
                    :grid="isMobile" :loading="isLoading" :filter="filters" :filter-method="applyFilters"
                    :pagination.sync="pagination" :rows-per-page-options="[10]" :hide-pagination="true" class="visit-q-table">
                    <!-- hide-pagination -->
                    <!-- Loading state -->
                    <template v-if="isLoading" v-slot:loading>
                        <div class="loading-state">
                            <q-spinner size="40px" color="primary" />
                            <span>Loading visits...</span>
                        </div>
                    </template>

                    <!-- Empty state (shared for grid + table) -->
                    <template v-if="!isLoading" v-slot:no-data>
                        <div class="empty-state">
                            <div class="empty-icon">
                                <q-icon name="event_busy" size="38px" />
                            </div>
                            <h3>No visits found</h3>
                            <p>There are no visit records matching your filters.</p>
                            <q-btn v-if="userRole.create" unelevated no-caps icon="add" label="Add New Visit"
                                class="primary-button" @click="createVisit" />
                        </div>
                    </template>

                    <!-- ===== DESKTOP ROW (table mode) ===== -->
                    <template v-if="!isLoading" v-slot:body="props">
                        <q-tr :props="props">
                            <q-td key="srNo" :props="props">
                                <span class="visit-id">{{ props.row.srNo }}</span>
                            </q-td>

                            <q-td key="accountName" :props="props">
                                <div class="dealer-info">
                                    <strong>{{ props.row.accountName || 'N/A' }}</strong>
                                    <small v-if="props.row.accountName">{{ props.row.accountTypeName }}</small>
                                </div>
                            </q-td>

                            <q-td key="date" :props="props">
                                <span class="date-value">{{ formatDate(props.row.visitDate) }}</span>
                            </q-td>

                            <q-td key="samName" :props="props">
                                <span class="normal-value">{{ props.row.samName }}</span>
                            </q-td>

                            <q-td key="visitPurposeName" :props="props">
                                <span class="purpose-badge">{{ props.row.visitPurposeName || 'N/A' }}</span>
                            </q-td>

                            <q-td key="address" :props="props">
                                <div class="location-info">
                                    <strong>{{ props.row.cityName || 'N/A' }}</strong>
                                    <small>
                                        {{ props.row.region || '' }}
                                        <span v-if="props.row.zoneName">· {{ props.row.zoneName }}</span>
                                    </small>
                                </div>
                            </q-td>

                            <q-td key="contact" :props="props">
                                <div class="contact-info">
                                    <strong>{{ props.row.contactPerson || 'N/A' }}</strong>
                                    <small v-if="props.row.mobile">{{ props.row.mobile }}</small>
                                </div>
                            </q-td>

                            <q-td key="gps" :props="props" class="text-center">
                                <q-btn v-if="hasLocation(props.row)" flat round dense icon="location_on"
                                    class="location-btn" @click="showMap(props.row)">
                                    <q-tooltip>View Location</q-tooltip>
                                </q-btn>
                                <span v-else class="no-location">—</span>
                            </q-td>

                            <q-td key="actions" :props="props" class="text-center actions-column">
                                <div class="row-actions">
                                    <q-btn :disable="!userRole.view" :class="{custom_class_without_right: !userRole.view}" flat round dense icon="visibility" class="view-action"
                                        @click="viewVisit(props.row)">
                                        <q-tooltip>View</q-tooltip> 
                                    </q-btn>
                                    <q-btn :disable="!userRole.edit" :class="{custom_class_without_right: !userRole.edit}" flat round dense icon="edit" class="edit-action"
                                        @click="editVisit(props.row)">
                                        <q-tooltip>Edit</q-tooltip>
                                    </q-btn>
                                    <!-- <q-btn :disable="!userRole.delete" :class="{custom_class_without_right: !userRole.delete}" flat round dense icon="delete" class="delete-action"
                                        @click="confirmDelete(props.row)">
                                        <q-tooltip>Delete</q-tooltip>
                                    </q-btn> -->
                                </div>
                            </q-td>
                        </q-tr>
                    </template>

                    <!-- ===== MOBILE CARD (grid mode) ===== -->
                    <template v-if="!isLoading" v-slot:item="props">
                        <article class="visit-card shadow-4 q-ma-sm" :class="{ 'is-expanded': isExpanded(props.row) }">
                            <!-- Header — always visible, tappable to toggle -->
                            <div class="visit-card-header" @click="toggleExpand(props.row)">
                                <div>
                                    <span class="visit-label">SR No</span>
                                    <strong class="visit-number">{{ props.row.srNo }}</strong>
                                </div>

                                <div class="header-right">
                                    <span class="date-badge">{{ formatDate(props.row.visitDate) }}</span>

                                    <q-icon name="expand_more" class="expand-icon" size="22px" />
                                </div>
                            </div>

                            <!-- Dealer — always visible (summary info) -->
                            <div class="dealer-block" @click="toggleExpand(props.row)">
                                <div class="dealer-icon">
                                    <q-icon size="md" name="business" />
                                </div>
                                <div>
                                    <strong>{{ props.row.accountName || '--' }}</strong>
                                    <small>{{ props.row.accountName || 'No account code' }}</small>
                                </div>
                            </div>

                            <!-- Expandable content -->
                            <q-slide-transition>
                                <div v-show="isExpanded(props.row)">
                                    <div class="card-details">
                                        <div class="detail-item">
                                            <span>Sales Manager</span>
                                            <strong>{{ props.row.samName }}</strong>
                                        </div>
                                        <div class="detail-item">
                                            <span>Purpose</span>
                                            <strong>{{ props.row.visitPurposeName || 'N/A' }}</strong>
                                        </div>
                                        <div class="detail-item">
                                            <span>Location</span>
                                            <strong>{{ props.row.cityName || 'N/A' }}</strong>
                                        </div>
                                        <div class="detail-item">
                                            <span>Contact</span>
                                            <strong>{{ props.row.contactPerson || props.row.mobile || 'N/A' }}</strong>
                                        </div>
                                    </div>

                                    <div class="visit-card-footer">
                                        <q-btn flat dense no-caps icon="location_on" label="Map" size="lg"
                                            class="map-btn" :disable="!hasLocation(props.row)"
                                            @click.stop="showMap(props.row)" />
                                        <q-space />
                                        <q-btn :disable="!userRole.view" :class="{custom_class_without_right: !userRole.view}" size="lg" flat round dense icon="visibility"
                                            class="view-action" @click.stop="viewVisit(props.row)" />
                                        <q-btn :disable="!userRole.edit" :class="{custom_class_without_right: !userRole.edit}" size="lg" flat round dense icon="edit"
                                            class="edit-action" @click.stop="editVisit(props.row)" />
                                        <q-btn :disable="!userRole.delete" :class="{custom_class_without_right: !userRole.delete}" size="lg" flat round dense icon="delete"
                                            class="delete-action" @click.stop="confirmDelete(props.row)" />
                                    </div>
                                </div>
                            </q-slide-transition>
                        </article>
                    </template>
                </q-table>

                <!-- CUSTOM FOOTER (replaces q-table's built-in pagination, same look as before) -->
                <div v-if="!isLoading && tableRows.length"
                    :class="isMobile ? 'mobile-pagination q-mb-lg' : 'pagination-wrapper'">
                    <span v-if="!isMobile" class="pagination-info">
                        Showing {{ paginationStart + 1 }} - {{ paginationEnd }} of {{ tableRows.length }}
                    </span>

                    <q-pagination v-model="pagination.page" :max="totalPages" :max-pages="isMobile ? 5 : 6"
                        direction-links :boundary-links="!isMobile" :size="$q.screen.lt.md ? 'lg' : 'md'" />
                </div>
            </section>
        </section>

        <!-- MAP DIALOG (unchanged) -->
        <q-dialog v-model="mapDialog" maximized>
            <q-card class="map-dialog">
                <q-bar class="map-header">
                    <div class="map-title">
                        <q-icon name="location_on" />
                        Visit Location
                    </div>
                    <q-space />
                    <q-btn flat round dense icon="close" v-close-popup />
                </q-bar>
                <div class="map-container">
                    <iframe v-if="mapUrl" :src="mapUrl" width="100%" height="100%" style="border: 0" allowfullscreen
                        loading="lazy" />
                </div>
            </q-card>
        </q-dialog>

        <!-- DELETE CONFIRMATION (unchanged) -->
        <q-dialog v-model="deleteDialog">
            <q-card class="delete-dialog">
                <q-card-section class="delete-dialog-header">
                    <div class="delete-icon">
                        <q-icon name="delete_outline" size="28px" />
                    </div>
                    <div>
                        <h3>Delete Visit?</h3>
                        <p>This action cannot be undone.</p>
                    </div>
                </q-card-section>

                <q-card-section class="delete-content">
                    Are you sure you want to delete visit
                    <strong>{{ selectedVisit?.srNo }}</strong>?
                </q-card-section>

                <q-card-actions align="right" class="delete-actions">
                    <q-btn flat no-caps label="Cancel" class="cancel-btn" v-close-popup />
                    <q-btn unelevated no-caps label="Delete Visit" icon="delete" class="confirm-delete-btn"
                        :loading="isDeleting" @click="deleteVisit" />
                </q-card-actions>
            </q-card>
        </q-dialog>
        <drawer ref="refDrawer" />
    </main>
</template>

<script>
    import { v4 as uuidV4 } from 'uuid';
    import axios from 'axios';
    import apis from '@/utilities';
    import Drawer from '../layout/drawer.vue';
    import api from '@/services/axios';
    import appHeader from '@/views/components/header.vue';
    // import XlsExport from 'xlsexport';
    import * as XLSX from 'xlsx/xlsx.mjs';

    export default {
        name: 'VisitList',
        components: { drawer: Drawer, appHeader },

        data() {
            return {
                isLoading: false,
                isDeleting: false,

                visits: [],
                regions: [],
                cities: [],
                samNames: [],

                filters: {
                    search: '',
                    fromDate: '',
                    toDate: '',
                    region: '',
                    city: '',
                    samName: '',
                },

                pagination: {
                    page: 1,
                    rowsPerPage: 5,
                },

                columns: [
                    { name: 'srNo', label: 'SR.No', field: 'srNo', align: 'left' },
                    { name: 'accountName', label: 'Account / Dealer', field: 'accountName', align: 'left' },
                    { name: 'date', label: 'Date', field: 'visitDate', align: 'left' },
                    { name: 'samName', label: 'Sales Acc. Manager', field: 'samName', align: 'left' },
                    { name: 'visitPurposeName', label: 'Purpose', field: 'visitPurpose', align: 'left' },
                    { name: 'address', label: 'Location', field: 'city', align: 'left' },
                    { name: 'contact', label: 'Contact', field: 'contactPerson', align: 'left' },
                    { name: 'gps', label: 'GPS', field: 'latitude', align: 'center' },
                    { name: 'actions', label: 'Actions', field: 'actions', align: 'left' },
                ],

                mapDialog: false,
                mapUrl: '',

                deleteDialog: false,
                selectedVisit: null,
                expandedRows: [],
                filtersExpanded: false,
                filterRegn: '',
                filtercity: '',
                filterSAM: '',
                userRole: {},
                isExporting: false
            };
        },

        computed: {
            url() {
                return this.$store.getters.url;
            },

            isMobile() {
                return this.$q.screen.width < 1024; // same 1024px jo CSS me hai
            },

            regionOptions() {
                return this.regions.map((e) => e.regionName).filter(Boolean);
            },

            cityOptions() {
                return this.cities.map((e) => e.cityName).filter(Boolean);
            },

            samOptions() {
                return this.samNames.map((e) => e.samName).filter(Boolean);
            },

            hasFilters() {
                return Object.values(this.filters).some((value) => !!value);
            },

            // Enrich raw visits once with resolved sam name, so both
            // desktop + mobile + search all use the exact same value.
            tableRows() {
                return this.visits
                    .map((visit) => ({
                        ...visit,
                        samDisplayName: visit.samName || this.samNames.find((e) => e.samName == visit.samName)?.samName || 'N/A',
                    }))
                    .filter((row) => this.applyFilters([row], this.filters).length);
            },

            totalPages() {
                return Math.max(1, Math.ceil(this.tableRows.length / this.pagination.rowsPerPage));
            },

            paginationStart() {
                if (!this.tableRows.length) return 0;
                return (this.pagination.page - 1) * this.pagination.rowsPerPage + 1;
            },

            paginationEnd() {
                return Math.min(this.pagination.page * this.pagination.rowsPerPage, this.tableRows.length);
            },
        },

        watch: {
            'filters.search'() {
                this.pagination.page = 1;
            },
            'filters.fromDate'() {
                this.pagination.page = 1;
            },
            'filters.toDate'() {
                this.pagination.page = 1;
            },
            'filters.region'() {
                this.pagination.page = 1;
            },
            'filters.city'() {
                this.pagination.page = 1;
            },
            'filters.samName'() {
                this.pagination.page = 1;
            },

            'pagination.page'(val) {
                if (val > this.totalPages) this.pagination.page = 1;
            },
        },

        mounted() {
                this.getVisits(),
                this.getCity(),
                this.getRegion(),
                this.getSalesAccountManagers(),
                this.setUserRole()
        },

        methods: {
            // Central filter used both by q-table (filter-method) and
            // internally by tableRows computed for accurate counts.
            setUserRole() {
                const {
                    menu: { permissions },
                } = this.$store.state;

                console.log('permissions: ', permissions);
                if (permissions) {
                    permissions?.map((m) => {
                        const accesstype = m.code?.split('.');
                        this.userRole[accesstype[accesstype?.length - 1]] = true;
                        console.log('userRole: ', this.userRole);
                    });
                }
            },
            applyFilters(rows, terms) {
                let data = rows;

                const search = (terms.search || '').toLowerCase().trim();

                if (search) {
                    data = data.filter((item) => {
                        const values = [
                            item.srNo,
                            item.accountName,
                            item.accountCode,
                            item.contactPerson,
                            item.mobile,
                            item.visitPurposeName,
                            item.cityName,
                            item.regionName,
                            item.zoneName,
                            item.samDisplayName,
                        ];
                        return values.filter(Boolean).some((value) => String(value).toLowerCase().includes(search));
                    });
                }

                if (terms.fromDate) {
                    data = data.filter((item) => String(item.visitDate).substring(0, 10) >= terms.fromDate);
                }

                if (terms.toDate) {
                    data = data.filter((item) => String(item.visitDate).substring(0, 10) <= terms.toDate);
                }

                if (terms.region) {
                    data = data.filter((item) => item.regionName === terms.region);
                }

                if (terms.city) {
                    data = data.filter((item) => item.cityName === terms.city);
                }

                if (terms.samName) {
                    data = data.filter((item) => item.samDisplayName === terms.samName);
                }

                return data;
            },

            async getVisits() {
                this.isLoading = true;
                this.visits = [];
                try {
                    const response = await api.get(`${this.url}/${apis.GetList}`);
                    this.visits = response.data.data || [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                } finally {
                    // this.$store.dispatch('triggerUnauthorizedError', err);
                    this.isLoading = false;
                }
            },

            async getCity() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetCity}`);
                    this.cities = response.data.data || [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                }
            },

            async getRegion() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetRegion}`);
                    this.regions = response.data.data || [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                }
            },

            async getSalesAccountManagers() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetSalesAccountManagers}`);
                    this.samNames = response.data.data || [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                }
            },

            clearFilters() {
                this.filters = { search: '', fromDate: '', toDate: '', region: '', city: '', samName: '' };
                this.pagination.page = 1;
            },

            createVisit() {
              const { id } = this.$store.state.menu;

                this.$router.push({
                    name: 'visitForm',
                    params: {
                        key: `${uuidV4()}_CREATE`,
                    },
                    query: {
                        id,
                    },
                });
            },

            viewVisit(visit) {
            const { id } = this.$store.state.menu;
                this.$router.push({
                    name: 'visitForm',
                    params: {
                        key: `${visit.srNo}_readOnly`,
                    },
                    query: {
                        id,
                    },
                });
            },
            editVisit(visit) {
                const { id } = this.$store.state.menu;
                const serverDate = visit.serverDate;
                const submittedAt = new Date(visit.createdWhen);
                const now = new Date(serverDate);
                const diffInHours = (now - submittedAt) / (1000 * 60 * 60);
                console.log('diffInHours: ', diffInHours);

                // if (diffInHours <= 72) {
                this.$router.push({
                    name: 'visitForm',
                    params: {
                        key: `${visit.srNo}_update`,
                    },
                    query: {
                        id,
                    },
                });
                // Edit allowed
                // } else {
                //     this.warningNotification('You can only edit visits within 24 hours of submission.')
                //     // Edit not allowed
                // }
            },

            confirmDelete(visit) {
                this.selectedVisit = visit;
                this.deleteDialog = true;
            },

            async deleteVisit() {
                if (!this.selectedVisit) return;
                this.isDeleting = true;
                try {
                    const response = await axios.delete(`${this.url}/${apis.DeleteVisit}/${this.selectedVisit.id || this.selectedVisit.srNo}`);
                    if (response.data.success) {
                        this.visits = this.visits.filter((item) => (item.id || item.srNo) !== (this.selectedVisit.id || this.selectedVisit.srNo));
                        this.$q.notify({ type: 'positive', message: 'Visit deleted successfully.', position: 'top' });
                        this.deleteDialog = false;
                        this.selectedVisit = null;
                    } else {
                        this.$q.notify({ type: 'negative', message: response.data.message || 'Unable to delete visit.', position: 'top' });
                    }
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                    this.$q.notify({ type: 'negative', message: 'Unable to delete visit.', position: 'top' });
                } finally {
                    this.isDeleting = false;
                }
            },

            hasLocation(visit) {
                return (
                    visit.latitude !== null &&
                    visit.latitude !== undefined &&
                    visit.latitude !== '' &&
                    visit.longitude !== null &&
                    visit.longitude !== undefined &&
                    visit.longitude !== ''
                );
            },

            showMap(visit) {
                if (!this.hasLocation(visit)) return;
                this.mapUrl = `https://www.google.com/maps?q=${visit.latitude},${visit.longitude}&output=embed`;
                this.mapDialog = true;
            },

            formatDate(date) {
                if (!date) return 'N/A';
                const value = String(date).substring(0, 10);
                const parts = value.split('-');
                if (parts.length !== 3) return value;
                return `${parts[2]}/${parts[1]}/${parts[0]}`;
            },

            logout() {
                sessionStorage.setItem('token', null);
                this.$store.commit('logOutHandler');
            },

            showDrawer() {
                if (this.$refs.refDrawer) {
                    this.$refs.refDrawer.toggleDrawer();
                }
            },

            isExpanded(row) {
                return this.expandedRows.includes(row.srNo);
            },

            toggleExpand(row) {
                const index = this.expandedRows.indexOf(row.srNo);

                if (index === -1) {
                    this.expandedRows.push(row.srNo);
                } else {
                    this.expandedRows.splice(index, 1);
                }
            },
            handleSelect(model, value) {
                this.filters[model] = value;
            },
            formatDateTime(date) {
                if (!date) return '';
                const d = new Date(date);
                if (Number.isNaN(d.getTime())) return '';
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                const hrs = String(d.getHours()).padStart(2, '0');
                const mins = String(d.getMinutes()).padStart(2, '0');
                return `${day}/${month}/${year} ${hrs}:${mins}`;
            },
            exportToExcel(rows) {
                if (!rows || !rows.length) {
                    this.$q.notify({ type: 'warning', message: 'No records to export.', position: 'top' });
                    return;
                }

                this.isExporting = true;

                try {
                    // Sirf readable/display columns nikal rahe hain — internal IDs
                    // (samId, regionId, cityId, etc.) skip kar diye, unke *Name
                    // wale readable versions use kiye hain.
                    const excelData = rows.map((row) => ({
                        'Sr No': row.srNo,
                        'Visit Date': this.formatDate(row.visitDate),
                        'SAM': row.samName,
                        'Visit Purpose': row.visitPurposeName,
                        'Region': row.regionName,
                        'Zone': row.zoneName,
                        'City': row.cityName,
                        'Market Catchment': row.marketCatchment,
                        'Dealer / Account': row.accountDealerName || row.accountName,
                        'Account Type': row.accountTypeName,
                        'Contact Person': row.contactPerson,
                        'Contact Role': row.contactRole,
                        'Mobile': row.mobile,
                        'Address': row.address,
                        'GPS Location': row.gpsLocationRef,
                        'Latitude': row.latitude,
                        'Longitude': row.longitude,
                        'Created At': this.formatDateTime(row.createdAt),
                        'Updated At': this.formatDateTime(row.updatedAt),
                    }));

                    const worksheet = XLSX.utils.json_to_sheet(excelData);
                    // Column widths readable rakhne ke liye auto-size karte hain
                    const colWidths = Object.keys(excelData[0]).map((key) => {
                        const maxLen = Math.max(
                            key.length,
                            ...excelData.map((r) => String(r[key] ?? '').length)
                        );
                        return { wch: Math.min(Math.max(maxLen + 2, 10), 45) };
                    });
                    worksheet['!cols'] = colWidths;

                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Visits');

                    const fileName = `visits_${new Date().toISOString().substring(0, 10)}.xlsx`;
                    XLSX.writeFile(workbook, fileName);

                    this.$q.notify({ type: 'positive', message: 'Excel file downloaded.', position: 'top' });
                } catch (err) {
                    console.error(err);
                    this.$q.notify({ type: 'negative', message: 'Unable to export Excel file.', position: 'top' });
                } finally {
                    this.isExporting = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.scss';
/* ============================================================
   BASE = MOBILE FIRST (no media query needed)
   ============================================================ */

.visit-page {
    min-height: 100vh;
    padding: 0;
    color: $primary;
    text-align: left;
}

.brand-logo-sera {
    height: 16px;
    margin-bottom: 10px;
}

.visit-shell {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
}

/* ================= HEADER ================= */

.visit-header {
    min-height: 170px;
    padding: 70px 18px 24px;
    display: flex;
    align-items: flex-start;
    gap: 18px;
    color: $primary;
    border-radius: 0;
    position: relative;
    background: #fff;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
}

.brand-mark {
    width: 42px;
    height: 42px;
    flex: 0 0 auto;
    display: grid;
    place-items: center;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
}

.header-content {
    min-width: 0;
}

.eyebrow {
    margin: 2px 0 5px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    opacity: 0.75;
}

h1 {
    margin: 0;
    font-size: 23px;
    line-height: 1.2;
    font-weight: 700;
}

.header-copy {
    margin: 7px 0 0;
    font-size: 12px;
    opacity: 0.85;
}

.header-actions {
    position: absolute;
    top: 14px;
    right: 14px;
    margin: 0;
    display: flex;
    gap: 8px;
}

.new-visit-btn {
    min-height: 38px;
    font-size: 15px;
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
}

.logout-link {
    color: $primary;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 18px;
}

/* ================= FILTER ================= */

.filter-card {
    padding: 20px 18px 15px;
    background: #fff;
    border-bottom: 1px solid #e5edef;
}

.filter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
}

.section-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.section-icon {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
    color: $primary;
    background: #e7f2f4;
    border-radius: 10px;
}

.section-title h2 {
    margin: 0;
    color: $primary;
    font-size: 17px;
}

.section-title p {
    margin: 3px 0 0;
    color: #73858a;
    font-size: 15px;
}

.refresh-btn {
    color: $primary;
}

.filter-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
}

.filter-footer {
    min-height: 40px;
    margin-top: 12px;
    display: flex;
    align-items: center;
}

.record-count {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #73858a;
    font-size: 15px;
}

.record-count .q-icon {
    color: $primary;
}

.clear-filter-btn {
    margin-left: auto;
    color: $primary;
}

/* ================= LIST CARD WRAPPER ================= */

.list-card {
    background: #fff;
    overflow: hidden;
}

/* ================= Q-TABLE OVERRIDES ================= */

.visit-q-table {
    :deep(.q-table__card) {
        box-shadow: none;
        background: transparent;
    }

    :deep(.q-table__middle) {
        box-shadow: none;
    }

    :deep(table) {
        width: 100%;
        min-width: 1100px;
        border-collapse: collapse;
    }

    :deep(thead tr th) {
        height: 50px;
        padding: 0 14px;
        color: #73858a;
        background: #f7fafb;
        border-bottom: 1px solid #e3ebed;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-align: left;
        text-transform: uppercase;
        white-space: nowrap;
    }

    :deep(tbody td) {
        height: 72px;
        padding: 8px 14px;
        color: #35525a;
        border-bottom: 1px solid #edf2f3;
        font-size: 13px;
        vertical-align: middle;
    }

    :deep(tbody tr) {
        transition: background 0.15s ease;
    }

    :deep(tbody tr:hover) {
        background: #f9fbfb;
    }

    /* Grid (mobile) mode container reset */
    :deep(.q-table__grid-content) {
        padding: 0;
        display: block;
        background: #f5f8f9;
    }

    :deep(.q-table__grid-item) {
        padding: 0;
        margin-bottom: 12px;
        width: 100%;
    }
}

/* ================= SHARED CELL CONTENT (used in both table + grid) ================= */

.visit-id {
    color: $primary;
    font-weight: 700;
    white-space: nowrap;
}

.date-value {
    color: #526a70;
    white-space: nowrap;
}

.dealer-info,
.location-info,
.contact-info {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.dealer-info strong,
.location-info strong,
.contact-info strong {
    color: #87969a;
    font-size: 12px;
    font-weight: 600;
}

.dealer-info small,
.location-info small,
.contact-info small {
    color: #87969a;
    font-size: 10px;
}

.normal-value {
    color: #87969a;
    white-space: nowrap;
}

.purpose-badge {
    display: inline-block;
    padding: 5px 8px;
    color: $primary;
    background: #e7f2f4;
    border-radius: 6px;
    font-size: 10px;
    white-space: nowrap;
}

.text-center,
.actions-column {
    text-align: center !important;
}

.location-btn {
    color: $primary;
}

.no-location {
    color: $primary;
}

.row-actions {
    display: flex;
    justify-content: center;
    gap: 2px;
}

.view-action {
    color: $primary;
}

.edit-action {
    color: $primary;
}

.delete-action {
    color: #c45151;
}

/* ================= PAGINATION ================= */

.pagination-wrapper {
    min-height: 65px;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 25px;
    border-top: 1px solid #edf2f3;
}

.pagination-info {
    margin-right: auto;
    color: #87969a;
    font-size: 12px;
}

.mobile-pagination {
    min-height: 60px;
    padding: 10px;
    display: flex;
    justify-content: center;
    background: transparent;
    margin-bottom: 20px !important;
}

/* ================= LOADING / EMPTY ================= */

.loading-state,
.empty-state {
    min-height: 300px;
    width: 100%;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.loading-state {
    gap: 12px;
    color: #73858a;
    font-size: 13px;
}

.empty-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
    display: grid;
    place-items: center;
    color: $primary;
    background: #e7f2f4;
    border-radius: 50%;
}

.empty-state h3 {
    margin: 0;
    color: $primary;
    font-size: 18px;
}

.empty-state p {
    margin: 6px 0 20px;
    color: #819297;
    font-size: 13px;
}

.primary-button {
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
}

/* ================= MOBILE CARD (grid item) ================= */

.visit-card {
    padding: 16px;
    background: #fff;
    border: 1px solid #e3ebed;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(27, 67, 77, 0.05);
    transition: box-shadow 0.2s ease;
}

.visit-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 14px;
    border-bottom: 1px solid #edf2f3;
    cursor: pointer;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 6px;
}

.visit-card.is-expanded {
    box-shadow: 0 6px 20px rgba(27, 67, 77, 0.1);
}

.expand-icon {
    color: #87969a;
    transition: transform 0.25s ease;
}

.visit-card.is-expanded .expand-icon {
    transform: rotate(180deg);
    color: #146b80;
}

.visit-label {
    display: block;
    margin-bottom: 3px;
    color: #8a9a9e;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
}

.visit-number {
    color: $primary;
    font-size: 15px;
}

.date-badge {
    padding: 5px 8px;
    color: $primary;
    background: #e7f2f4;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
}

.dealer-block {
    margin: 14px 0;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.dealer-icon {
    width: 40px;
    height: 40px;
    display: grid;
    place-items: center;
    color: $primary;
    background: #e7f2f4;
    border-radius: 9px;
}

.dealer-block strong {
    display: block;
    color: rgba(0, 0, 0, 0.87);
    font-size: 15px;
}

.dealer-block small {
    color: #819297;
    font-size: 12px;
}

.card-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 13px;
    padding-top: 14px;
    border-top: 1px solid #edf2f3;
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.detail-item span {
    color: #91a1a5;
    font-size: 12px;
}

.detail-item strong {
    color: rgba(0, 0, 0, 0.87);
    font-size: 15px;
    font-weight: 400;
}

.visit-card-footer {
    margin-top: 15px;
    padding-top: 10px;
    display: flex;
    align-items: center;
    border-top: 1px solid #edf2f3;
}

.visit-card-footer .q-btn {
    min-width: 40px;
    min-height: 40px;
}

.map-btn {
    color: $primary;
    font-size: 11px;
}

/* ================= MAP DIALOG ================= */

.map-dialog {
    display: flex;
    flex-direction: column;
}

.map-header {
    min-height: 50px;
    color: #fff;
    background: $primary;
}

.map-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
}

.map-container {
    flex: 1;
    min-height: 0;
}

.map-container iframe {
    display: block;
}

/* ================= DELETE DIALOG ================= */

.delete-dialog {
    width: 420px;
    max-width: calc(100vw - 30px);
    border-radius: 14px;
}

.delete-dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.delete-icon {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    color: #c45151;
    background: #fceeee;
    border-radius: 10px;
}

.delete-dialog-header h3 {
    margin: 0;
    color: $primary;
    font-size: 17px;
}

.delete-dialog-header p {
    margin: 3px 0 0;
    color: #87969a;
    font-size: 12px;
}

.delete-content {
    color: #526a70;
    font-size: 13px;
}

.delete-content strong {
    color: $primary;
}

.delete-actions {
    padding: 12px 16px 16px;
}

.cancel-btn {
    color: #55757d;
}

.confirm-delete-btn {
    color: #fff;
    background: #c45151;
    border-radius: 7px;
}

.mobile-select-menu {
    position: fixed !important;
    left: 10px !important;
    right: 10px !important;
    top: 100px !important;
    // width: calc(100vw - 20px) !important;
    height: 60vh !important;
}

// ::v-deep .sam-select-popup {
//         padding: 0 !important;
//     }

//     ::v-deep .sam-select-popup .search-option-field {
//         position: sticky !important;
//         top: 0 !important;
//         z-index: 9999 !important;
//         background: #fff !important;
//     }

// .search-option-field{
//        position: sticky !important;
//         top: 0 !important;
//         left: 0 !important;
//         right: 0 !important;
//         width: 100% !important;
//         z-index: 99999 !important;
//         background: white !important;
//         padding: 10px !important;
// }
.custom_class_without_right{
    color: gray !important;
}
/* ============================================================
   ENHANCE FOR TABLET (>= 641px)
   ============================================================ */

@media (min-width: 641px) {
    .visit-page {
        padding: 32px 16px;
    }

    .visit-shell {
        max-width: 100%;
    }

    .new-visit-btn {
        min-height: 38px;
        font-size: 11px;
        color: #fff;
        background: $primary-gradient;
        border-radius: 8px;
    }

    .visit-header {
        min-height: 145px;
        padding: 30px 34px;
        border-radius: 20px 20px 0 0;
        box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
    }

    .brand-mark {
        width: 48px;
        height: 48px;
    }

    h1 {
        font-size: 28px;
    }

    .header-copy {
        font-size: 14px;
    }

    .header-actions {
        position: static;
        margin-left: auto;
    }

    .filter-card {
        padding: 25px 34px 18px;
    }

    .filter-header {
        margin-bottom: 22px;
    }

    .section-title h2 {
        font-size: 19px;
    }

    .section-title p {
        font-size: 15px;
    }

    .filter-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px;
    }

    .filter-footer {
        margin-top: 15px;
    }

    .record-count {
        display: flex;
        align-items: center;
        gap: 6px;
        color: #73858a;
        font-size: 12px;
    }
}

.sub-heading {
    color: $magenta !important;
}

/* ============================================================
   ENHANCE FOR SMALL DESKTOP / LARGE TABLET (>= 800px)
   ============================================================ */

@media (max-width: 1024px) {
    .filter-grid {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
}

/* ============================================================
   ENHANCE FOR DESKTOP (>= 1024px) — table mode kicks in
   ============================================================ */

@media (min-width: 1024px) {
    .filter-grid {
        grid-template-columns: 1.6fr repeat(5, 1fr);
    }

    .visit-shell {
        max-width: 100%;
    }

    .pagination-wrapper {
        justify-content: flex-end;
    }
}

@media (min-width: 1201px) {
    .filter-grid {
        grid-template-columns: 1.6fr repeat(5, 1fr);
    }

    .visit-shell {
        max-width: 80vw;
    }

    .pagination-wrapper {
        justify-content: flex-end;
    }
}
</style>
/* Neutralize q-table's own chrome so our custom classes control the look */
.visit-q-table {
:deep(.q-table__card),
:deep(.q-table__middle) {
box-shadow: none;
}

:deep(table) {
width: 100%;
min-width: 1100px;
border-collapse: collapse;
}

:deep(thead tr th) {
height: 50px;
padding: 0 14px;
color: #73858a;
background: #f7fafb;
border-bottom: 1px solid #e3ebed;
font-size: 10px;
font-weight: 700;
letter-spacing: 0.04em;
text-align: left;
text-transform: uppercase;
white-space: nowrap;
}

:deep(tbody td) {
height: 72px;
padding: 8px 14px;
color: #35525a;
border-bottom: 1px solid #edf2f3;
font-size: 13px;
vertical-align: middle;
}

:deep(tbody tr:hover) {
background: #f9fbfb;
}

/* grid (mobile) mode container reset */
:deep(.q-table__grid-content) {
padding: 0;
display: block;
background: #f5f8f9;
}

:deep(.q-table__grid-item) {
padding: 0;
margin-bottom: 12px;
}
}
Clear Copy
https://www.google.com/maps?q=${visit.latitude},${visit.longitude}&output=embed`;
© 2011-2026 AirForShare.com
Made in BirdsCorp.com with ❤️
